import { TimberBuyerProfile } from '@features/TimberBuyer/Profile/TimberBuyerProfile'
import { useTimberBuyerContext } from '@features/TimberBuyer/TimberBuyerContext'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/timberbuyer/$timberBuyerId/')({
  component: TimberBuyerOverviewRoute,
  staticData: {
    breadcrumb: 'Oversikt',
  },
})

function TimberBuyerOverviewRoute() {
  const { timberBuyerId } = Route.useParams()
  const { data, isLoading, isError } = useTimberBuyerContext()

  return (
    <TimberBuyerProfile
      timberBuyerId={timberBuyerId}
      activePage="overview"
      data={data}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
